import React from 'react';
import { Alert, Box, Breadcrumbs, Button, Link, Paper, Typography } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import AuditDynamicFormRHFNew from '../../../../components/audit/AuditDynamicFormRHFNew';
import type { CreateAuditFormViewProps } from '../../../../types/auditFormTypes';
import { formatDateMMDDYYYY } from '../../../../utils/formatUtils';

const CreateAuditFormView: React.FC<CreateAuditFormViewProps> = ({
  storeName,
  shiftDate,
  shiftStartTime,
  shiftEndTime,
  previousAuditCount,
  formData,
  gamesMapState,
  saving,
  hoveredRowIndex,
  onBack,
  onBackToAuditList,
  onSubmit,
  onFormDataUpdate,
  onRowHover,
}) => {
  return (
    <Box sx={{ gap: 2, display: 'flex', flexDirection: 'column' }}>
      <Paper elevation={1} sx={{ p: 2, borderBottom: '1px solid #ddd' }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Box>
            <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 1 }}>
              <Link
                color="rgba(44, 108, 160, 1)"
                href="#"
                onClick={(event) => {
                  event.preventDefault();
                  onBackToAuditList();
                }}
                sx={{ cursor: 'pointer' }}
              >
                Audit
              </Link>
              <Link
                color="rgba(44, 108, 160, 1)"
                href="#"
                onClick={(event) => {
                  event.preventDefault();
                  onBack();
                }}
                sx={{ cursor: 'pointer' }}
              >
                Create New Audit
              </Link>
              <Typography color="text.primary" fontWeight={600}>Audit Form</Typography>
            </Breadcrumbs>
            <Typography variant="h5" component="h1" fontWeight={600}>
              Create Audit for {storeName}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Shift: {formatDateMMDDYYYY(shiftDate, 'N/A')} | {shiftStartTime || 'N/A'} - {shiftEndTime || 'N/A'}
            </Typography>
          </Box>

          <Button variant="outlined" startIcon={<ArrowBack />} onClick={onBack} sx={{ minWidth: 120 }}>
            Back
          </Button>
        </Box>
      </Paper>

      <Box
        sx={{
          width: '100%',
          maxWidth: { xs: '100%', md: '40%' },
          mx: 'auto',
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        {previousAuditCount > 0 && (
          <Alert severity="info">
            Loaded {previousAuditCount} records from the previous audit. They are now pre-populated as the starting point for this manual audit.
          </Alert>
        )}

        <Paper elevation={0} sx={{ p: 3, borderRadius: 3 }}>
          <AuditDynamicFormRHFNew
            storeName={storeName}
            initialValues={formData}
            onSubmit={onSubmit}
            isSubmitting={saving}
            auditStatus=""
            ticketDetails={formData.ticket_details || []}
            onFormDataUpdate={onFormDataUpdate}
            onSwitchModes={() => {}}
            gamesData={gamesMapState}
            hoveredRowIndex={hoveredRowIndex}
            onRowHover={onRowHover}
            onRevertToReady={() => {}}
            showTopBar={false}
            showConfidenceChip={false}
            showJsonToggle={false}
            showRejectAction={false}
            showRevertAction={false}
            submitButtonLabel="Create Audit"
          />
        </Paper>
      </Box>
    </Box>
  );
};

export default CreateAuditFormView;
